
















import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { analysisStores } from '@/store/poultry/analysis';
import dayjs, { Dayjs} from 'dayjs';
import { ScoreAnalysis } from '@/models/poultry/analysis.model';
import { setFormattedDate } from '@/utils/date.formatter';

@Component({
  components: {}
})

export default class HatcheryAnalysisTableBody extends Vue {
  store = analysisStores.hatchery.list;

  get hatcheries() {
    return this.store.sortedHatcheries;
  }

  getPublishedMonth(date: string) {
    return setFormattedDate(date);
  }
}
